export const w4 = {
    'images': [],
    'mainFeatures': [
        'Nano Graphite Coating with Nature Rubber (Winter Rubber formula)',
        'Patented Multi-functional Mounting Base & Adapters',
        'Rubber Casing Design Provides for 100% waterproof',
        'Designed Specific Rubber Profile to Reduce Noise and Friction',

    ],
    'material': [
        'Rubber: Premium Nature Rubber with Winter Rubber formula',
        'Steel: SGCC, Electrostatic Powder Coating.',
        'Rivet: Steel Rivet',
        'Plastic (Spacer & Adapter): POM ',
    ],
    'featureIcons': ["11", "02", "03", "07"],
    'otherFeatures': ["01", "02"],
    'specification': [
        { "inch": "12", "mm": "306", "claw": "4", "width": "6", "thickness": "1.0" },
        { "inch": "13", "mm": "336", "claw": "6", "width": "6", "thickness": "1.0" },
        { "inch": "14", "mm": "361", "claw": "6", "width": "6", "thickness": "1.0" },
        { "inch": "15", "mm": "384", "claw": "6", "width": "6", "thickness": "1.0" },
        { "inch": "16", "mm": "409", "claw": "6", "width": "6", "thickness": "1.0" },
        { "inch": "17", "mm": "436", "claw": "6", "width": "6", "thickness": "1.0" },
        { "inch": "18", "mm": "457", "claw": "6", "width": "6", "thickness": "1.0" },
        { "inch": "19", "mm": "486", "claw": "6", "width": "6", "thickness": "1.0" },
        { "inch": "20", "mm": "508", "claw": "6", "width": "6", "thickness": "1.0" },
        { "inch": "21", "mm": "532", "claw": "8", "width": "6", "thickness": "1.0" },
        { "inch": "22", "mm": "556", "claw": "8", "width": "6", "thickness": "1.0" },
        { "inch": "24", "mm": "606", "claw": "6", "width": "6", "thickness": "1.0" },
        { "inch": "26", "mm": "656", "claw": "6", "width": "6", "thickness": "1.0" }
    ],
    'adapters': ['b1', 'b6', 'bl-2a', 'cl+cl-r', "m3", 'm4', 'm5', 'ml', 'ph-3', 'pl', 'pt-3', 'pt6', 'pt-r', 'tl-2', 'tl4a', 'tlc', 'a3']
}
